import { reminderSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { i18n } from "@src/i18n/i18n";

export const logoutTimer = (debug = false) => {
  // Set the timeout period (e.g., 30 minutes)
  const AMOUNT_OF_MINUTES = 60 * 4; // 4 hours
  const WARNING_AMOUNT_OF_MINUTES = 5;
  const SECONDS_IN_A_MINUTE = 60;
  const MILLISECONDS_IN_A_SECOND = 1000;
  const SHOW_REMINDER_DURATION_TIME_IN_MILLISECONDS = 15000;

  const TIMEOUT_PERIOD_IN_MILLISECONDS =
    AMOUNT_OF_MINUTES * SECONDS_IN_A_MINUTE * MILLISECONDS_IN_A_SECOND;

  const WARNING_PERIOD_IN_MILLISECONDS =
    TIMEOUT_PERIOD_IN_MILLISECONDS -
    WARNING_AMOUNT_OF_MINUTES * SECONDS_IN_A_MINUTE * MILLISECONDS_IN_A_SECOND;

  const log = (string) => {
    if (debug) {
      console.log(string);
    }
  };

  // Function to log out the user
  const logoutUser = () => {
    // Implement your logout logic here
    log("Logging out user...");
    window.location.href = "/logout";
  };

  const startTimer = () => {
    if (isLoginOrLogoutPage()) {
      log("Not starting timer on login or logout page.");
      return;
    }

    log("Starting timer...");
    return setTimeout(logoutUser, TIMEOUT_PERIOD_IN_MILLISECONDS);
  };

  // Function to display a warning before session timeout
  const showTimeoutWarning = () => {
    reminderSnackbar(
      i18n("modules.logoutTimer.warning"),
      SHOW_REMINDER_DURATION_TIME_IN_MILLISECONDS,
    );
  };

  const isLoginOrLogoutPage = () => {
    const loginPage = window.location.pathname === "/login";
    const logoutPage = window.location.pathname === "/logout";
    return loginPage || logoutPage;
  };

  const startWarningTimer = () => {
    if (isLoginOrLogoutPage()) {
      log("Not starting timer on login or logout page.");
      return;
    }

    log("Starting warning timer...");
    return setTimeout(showTimeoutWarning, WARNING_PERIOD_IN_MILLISECONDS);
  };

  // Start session timeout timer
  let sessionTimeout = startTimer();
  let warningTimeout = startWarningTimer();

  // Reset the timer on user activity
  const resetSessionTimeout = () => {
    if (isLoginOrLogoutPage()) {
      log("Not resetting timer on login or logout page.");
      return;
    }

    log("Resetting timer...");
    clearTimeout(sessionTimeout);
    clearTimeout(warningTimeout);
    sessionTimeout = startTimer();
    warningTimeout = startWarningTimer();
  };

  // Listen for user activity events
  window.addEventListener("mousemove", resetSessionTimeout);
  window.addEventListener("keypress", resetSessionTimeout);
};
